<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div class="vx-row px-4" v-if="showFilters">
          <div class="vx-col w-full">
            <form class="vx-row flex items-end flex-wrap gap-y-4">
              <div class="w-2/3 flex-grow">
                <div class="vx-col w-full mt-1">
                  <div class="w-full">
                    <vs-input
                      class="inputx my-1"
                      v-model="gridSearchData.name"
                      :label="$t('ProductName')"
                    />
                  </div>
                </div>
              </div>
              <div class="w-1/3 flex-grow" style="min-width: 300px">
                <div class="vx-col w-full">
                  <vs-button
                    type="filled"
                    class="float-right"
                    @click.prevent="submitFilter()"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                  <vs-button
                    type="filled"
                    class="float-right ml-4"
                    id="reset-btn"
                    @click.prevent="resetForm"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="vx-row pt-6">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('ProductStatus'), sort: 'ProductStatus' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('ModelNumber'), sort: 'ModelNumber' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 42%" :title="row.stockName">
                  {{ row.name }}
                </td>
                <td style="width: 18%">
                  <span v-if="row.stockType == 1">{{ $t("Serialize") }}</span>
                  <span v-else-if="row.stockType == 2">{{
                    $t("Measurable")
                  }}</span>
                </td>
                <td style="width: 12%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 12%">
                  {{ row.modelNumber }}
                </td>
                <td style="width: 14%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "warehouseManagement_Products_All",
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "/Inventory/api/StockQuery",
      },
      gridSearchData: {
        isStockTypeDetermined: "true",
      },
      showFilters: false,
    };
  },
  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        name: "",
        isStockTypeDetermined: "true",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
